import { SafeSpace, TaskStatus } from '../types';
import transactInSpace from './transactInSpace';
import * as Y from 'yjs';
import { ymapFromRecord } from '../yjs-utils';
import { v4 as uuidv4 } from 'uuid';

export default function addTaskStatusDefinitions(space: SafeSpace, name: string, parentStatus: TaskStatus) {
    const id = uuidv4();

    transactInSpace(space, () => {
        let taskStatuses = space.map.get('taskStatuses') as Y.Array<Y.Map<unknown>> | undefined;

        if (!taskStatuses) {
            taskStatuses = new Y.Array();
            space.map.set('taskStatuses', taskStatuses);
        }

        for (const statusMap of taskStatuses) {
            if (statusMap.get('status') === parentStatus) {
                const subStatusArray = statusMap.get('subStatus') as Y.Array<Y.Map<unknown>>;
                if (!subStatusArray) {
                    statusMap.set('subStatus', new Y.Array());
                }
                (statusMap.get('subStatus') as Y.Array<Y.Map<unknown>>).push([
                    ymapFromRecord({ id, status: name }, new Y.Map()),
                ]);

                return;
            }
        }

        const newStatusMap = new Y.Map();
        newStatusMap.set('status', parentStatus);
        newStatusMap.set('subStatus', new Y.Array());

        const subStatusArray = newStatusMap.get('subStatus') as Y.Array<Y.Map<unknown>>;
        subStatusArray.push([ymapFromRecord({ id, status: name }, new Y.Map())]);

        taskStatuses.push([newStatusMap]);
    });
}
